<template>
    <div
        class="app-quote-radio-buttons"
        :class="{
            'rounded-small': roundedSmall,
            fixed: fixed,
            'fixed-mobile': fixedMobile,
            'break-mobile': breakMobile,
            circle: circle
        }"
    >
        <div class="radio-buttons-wrap">
            <label
                :key="item.value"
                v-for="item in items"
                :class="{
                    checked: newValue === item.value,
                    'rounded-small': roundedSmall,
                    fixed: fixed,
                    'fixed-mobile': fixedMobile,
                    circle: circle
                }"
            >
                <template v-if="item.icon">
                    <template v-if="item.icon_amount">
                        <span v-if="item.value === 'any'">
                            <span class="svg-icon"> + </span>
                        </span>
                        <span
                            v-for="i in item.icon_amount"
                            :key="i"
                            class="svg-icon"
                            v-html="
                                $icon(
                                    newValue === item.value
                                        ? item.icon_checked
                                        : item.icon
                                )
                            "
                        ></span>
                    </template>

                    <template v-else-if="item.value === 'any'">
                        <span class="svg-icon">+</span>
                        <span
                            v-for="i in 2"
                            :key="i"
                            class="svg-icon"
                            v-html="$icon(icon)"
                        ></span>
                    </template>

                    <template v-else>
                        <span
                            class="svg-icon"
                            v-html="
                                $icon(
                                    newValue === item.value
                                        ? item.icon_checked
                                        : item.icon
                                )
                            "
                        ></span>
                    </template>
                </template>

                <input
                    type="radio"
                    :value="item.value"
                    v-model="newValue"
                    @change="onInput"
                />

                <span class="label">{{ item.label }}</span>
            </label>
        </div>

        <p class="message" v-if="message">{{ message }}</p>
    </div>
</template>

<script>
export default {
    props: {
        message: String,
        items: Array,
        roundedSmall: Boolean,
        fixed: Boolean,
        fixedMobile: Boolean,
        value: [String, Boolean, Number],
        icon: String,
        breakMobile: false,
        circle: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            newValue: this.value
        };
    },

    watch: {
        value() {
            this.newValue = this.value;
        }
    },

    methods: {
        onInput() {
            this.$emit("input", this.newValue);
            this.$emit("change", this.newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
.svg-icon {
    margin-left: 10px;
}
.app-quote-radio-buttons {
    position: relative;
    width: 100%;

    &.circle {
        width: fit-content;
    }
}

.app-quote-radio-buttons.rounded-small .radio-buttons-wrap {
    gap: 15px;
}

.app-quote-radio-buttons {
    @media all and (max-width: $mobile) {
        &.break-mobile {
            width: 100%;

            .radio-buttons-wrap {
                display: flex;
                flex-direction: column;
                width: 100%;

                label {
                    width: 100%;
                    //max-width: 70%;
                    margin-right: 0;
                    margin-bottom: 20px;
                }
            }
        }
    }
}

.app-quote-radio-buttons label {
    /* Styling for the radio button label */
    font-size: 20px;
    font-weight: $font-semi-bold;
    color: $dark-gray;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border: solid 1px rgba(33, 67, 146, 0.2);
    background-color: $lightest-gray;
    transition: border 0.2s ease-in-out;
    cursor: pointer;
    border-radius: 100px;
    margin-right: 40px;
    flex: 1;

    &.circle {
        border-radius: 50%;
        width: 50px;
    }

    &:first-child {
        margin-right: 0;
    }

    @media all and (max-width: $mobile) {
        width: 112px;
        height: 52px;
    }

    &.fixed {
        flex: 1;
        width: auto;
    }

    &.fixed-mobile {
        @media all and (max-width: $mobile) {
            flex: 1;
            width: auto;
        }
    }

    /* Styling for the checked radio button */
    &.checked {
        border: none;
        background: var(
            --linear,
            linear-gradient(90deg, $primary-blue 0%, $cyan 100%)
        );

        span.label {
            color: $white;
            font-size: 20px;
            font-weight: $font-bold;
        }
    }

    /* Styling for the label text */
    span.label {
        color: $dark-gray;
        text-align: right;
        font-size: 20px;
        font-style: normal;
        font-weight: $font-semi-bold;
        line-height: 38.46px;
        transition: color 0.2s ease-in-out;

        @media all and (max-width: $mobile) {
            font-size: 20px;
            font-weight: $font-light;
        }
    }
}

.app-quote-radio-buttons .radio-buttons-wrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.app-quote-radio-buttons input {
    width: 0;
    height: 0;
    position: absolute;
    pointer-events: none;
}

.app-quote-radio-buttons .message {
    font-size: 1rem;
    margin: 10px 0 0;
    color: $error-red;
    font-weight: $font-normal;
}
</style>
